export const frostDamageConstants = {
    SET_FROST_DAMAGES: 'FROST_DAMAGE_SET_FROST_DAMAGES',
    SET_FROST_DANGER: 'FROST_DAMAGE_SET_FROST_DANGER',
    SET_FROST_MEPAR: 'FROST_DAMAGE_SET_FROST_MEPAR',
    SET_FROST_CITY: 'FROST_DAMAGE_SET_FROST_CITY',
};
